import { Component, Input } from '@angular/core';
import { isUndefined } from '@skylab-shared/utils';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'skl-dialog-content-ins',
    templateUrl: './dialog-content-ins.component.html',
    styles: [
        `
            :host {
                position: relative;
            }

            .dialog-content-spinner {
                height: 500px;
                display: block;
                position: relative;
            }
        `
    ],
    imports: [SpinnerComponent]
})
export class DialogContentComponentIns {
    @Input() public isReady!: boolean | null | undefined;

    public get showContent() {
        return isUndefined(this.isReady) || ((this.isReady || false) === true);
    }
}
